export default "__VITE_ASSET__Dl7QeXzx__"